export default "__VITE_ASSET__CEVeRO9X__"